import React from 'react'
import DashboardNav from './Components/DashboardNav'
import CustomUrl from './Components/CustomUrl'
import Footer from '../LandingPage/Components/Footer'

function CustomUrlPage() {
    return (
        <div>
            <DashboardNav />
            <CustomUrl />
            <Footer />
        </div>
    )
}

export default CustomUrlPage